export default __webpack_public_path__ + "static/media/login_image.3d4fbcd9.jpeg";